import { createRoute, createRouter, type RouterHistory, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/root-route.tsx';
import { conversationRoute, inboxRoute, legacyDecisionsRoute } from '@/features/inbox/routes.tsx';
import {
  medicalOrderRoute,
  medicalOrdersRoute,
  newMedicalOrderRoute,
} from '@/features/medical-orders/routes.tsx';
import { newRunRoute, runRoute, runsRoute } from '@/features/submission-runs/routes.tsx';
import {
  newSubmissionRoute,
  submissionDetailRoute,
  submissionsListRoute,
} from '@/features/submissions/routes.tsx';

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/submissions', replace: true });
  },
});

// ---------------------------------------------------------------------------------------------
// ROUTE REGISTRATION POINT
//
// To add a page: define its route in `src/features/<area>/routes.tsx` (child of `rootRoute`),
// import it above and add it to the list below. Routes are listed explicitly (not spread from
// an array) so TanStack Router can infer the full route tree for type-safe links.
// Navigation entries live separately in `src/app/nav.ts`.
// ---------------------------------------------------------------------------------------------
const routeTree = rootRoute.addChildren([
  indexRoute,
  runsRoute,
  newRunRoute,
  runRoute,
  submissionsListRoute,
  newSubmissionRoute,
  submissionDetailRoute,
  inboxRoute,
  conversationRoute,
  legacyDecisionsRoute,
  medicalOrdersRoute,
  newMedicalOrderRoute,
  medicalOrderRoute,
]);

export function createAppRouter(options: { history?: RouterHistory } = {}) {
  return createRouter({
    routeTree,
    defaultPreload: 'intent',
    ...(options.history ? { history: options.history } : {}),
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
